module.exports = __webpack_public_path__ + "static/media/IMG_1284.4e4a7d74.jpg";